module.exports = __webpack_public_path__ + "static/media/finallogo.67eb4c54.mp4";